import React, { useEffect, useRef, useState } from "react";
import {
  message,
  Button,
  Form,
  Input,
  Row,
  Col,
  Modal,
  Upload,
  Select,
} from "antd";
import { addBanner, editBanner } from "./BannerApi";
import { MdUpload } from "react-icons/md";
import { DownOutlined } from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
const AddBanner = ({ isOpen, setIsOpen, from, Fill, apiCall, current }) => {
  const [form] = Form.useForm();
  const formRef = useRef(form);
  const MAX_FILE_SIZE_MB = 25;
  const [fileLists, setFileLists] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  console.log(Fill);
  const createBanner = (changedValues) => {
    setIsLoading(true);
    const formData = new FormData();
    if (fileLists.length > 0) {
      formData.append("image", fileLists[0]);
    }
    formData.append("type", changedValues.type);
    formData.append("tag", changedValues.tag);
    formData.append("title", changedValues.title);
    formData.append("description", changedValues.description);

    addBanner(formData)
      .then((response) => {
        if (response.data.status) {
          message.success({ content: response.data.message });
          apiCall(current);
          setIsOpen(false);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const EditBanner = (changedValues) => {
    const formData = new FormData();
    if (fileLists.length > 0) {
      formData.append("image", fileLists[0]);
    }
    formData.append("type", changedValues.type);
    formData.append("tag", changedValues.tag);
    formData.append("title", changedValues.title);
    formData.append("description", changedValues.description);

    setIsLoading(true);
    editBanner(formData, `${Fill.id}`)
      .then((response) => {
        if (response.data.status) {
          message.success({ content: response.data.message });
          apiCall(current);
          setIsOpen(false);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        form.resetFields();
        if (from === "add") {
          createBanner(values);
        } else {
          EditBanner(values);
        }
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  const uploadProps = {
    name: "file",
    accept: ".jpg,.jpeg,.png,.pdf",
    multiple: false, // Assuming you only want one file
    beforeUpload: (file) => {
      const isLt25M = file.size / 1024 / 1024 < MAX_FILE_SIZE_MB;
      if (!isLt25M) {
        message.error(`File must be smaller than ${MAX_FILE_SIZE_MB}MB!`);
        return Upload.LIST_IGNORE;
      }

      setFileLists([file]);
      return false;
    },
    fileList: fileLists,
    onRemove: (file) => {
      setFileLists([]); // Clear the file list on removal
    },
  };
  useEffect(() => {
    if (from === "edit" && Fill.image_path) {
      const initialFileList = [
        {
          name: Fill.image_name,
          status: "done",
          id: Fill.id,
          url: `${process.env.REACT_APP_IMAGE_URL}${Fill.image_path}`,
        },
      ];
      setFileLists(initialFileList);
    }
  }, [from, Fill]);
  return (
    <Modal
      footer={null}
      visible={isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      title={from === "add" ? "Add Banner" : "Edit Banner"}
    >
      <Form
        className="bg-rgbaprimary1 p-4 mt-4"
        layout="vertical"
        onFinishFailed={(err) => console.log(err)}
        onFinish={from === "add" ? createBanner : EditBanner}
        form={form}
        ref={formRef}
        initialValues={
          from === "add"
            ? ""
            : {
                image: Fill.image_path,
                type: Fill.type,
                title: Fill.title,
                tag: Fill.tag,
                description: Fill.description,
              }
        }
      >
        <Row className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Col>
            <Form.Item
              name="image"
              label={from === "add" ? "Upload Banner" : "Edit Banner"}
              rules={[
                {
                  required: true,
                  message: "Please upload an image",
                },
              ]}
            >
              <Upload {...uploadProps}>
                <Button icon={<MdUpload />} className="w-52">
                  Upload Banner{" "}
                </Button>
              </Upload>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item
              name="type"
              label="Banner Type"
              rules={[
                {
                  required: true,
                  message: "Please select a banner type",
                },
              ]}
            >
              <Select
                suffixIcon={
                  <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                }
                placeholder="Select banner type"
                options={["property", "jobs", "products", "automobile"].map(
                  (i) => ({
                    label: i.toString().toUpperCase(),
                    value: i.toString(),
                  })
                )}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Col>
            <Form.Item
              name="tag"
              label="Banner Tag"
              rules={[
                {
                  required: true,
                  message: "Please select a banner Tag",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item
              name="title"
              label="Banner Title"
              rules={[
                {
                  required: true,
                  message: "Please select a banner Title",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row className="grid grid-cols-1 ">
          <Col>
            <Form.Item
              name="description"
              label="Description"
              rules={[
                { required: true, message: "Please enter a description" },
              ]}
            >
              <ReactQuill
                theme="snow"
                className="bg-white"
                onChange={(value) =>
                  form.setFieldsValue({ description: value })
                }
                placeholder="Write your banner description here..."
              />
            </Form.Item>
          </Col>
        </Row>
        <Row className="flex justify-between gap-4">
          <Form.Item className="mt-4">
            <Button
              className="bg-white text-rgbaprimary9  hover:!bg-rgbaprimary8 hover:!text-white hover:!border-none"
              htmlType="reset"
            >
              Cancel
            </Button>
          </Form.Item>
          <Form.Item className="mt-4">
            <Button
              className="bg-rgbaprimary9 text-white  hover:!bg-rgbaprimary8 hover:!text-white hover:!border-none"
              htmlType="submit"
              disabled={isLoading}
              loading={isLoading}
            >
              {from === "add" ? "Create Banner" : "Edit Banner "}
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddBanner;
